export default "__VITE_ASSET__9e18bf8f__"